import React, { useState, useEffect } from 'react';
import contentService from '../services/contentService';
import InfluencerModal from './InfluencerModal';
import InfluencerModalInstagramDetalle from './InfluencerModalInstagramDetalle';
import InfluencerModalTikTokDetalle from './InfluencerModalTikTokDetalle';
import Loading from './Loading';
import './InfluencerList.css';

const InfluencerList = () => {
  const [influencers, setInfluencers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedInfluencer, setSelectedInfluencer] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [generatedLink, setGeneratedLink] = useState('');
  const [linkInfluencer, setLinkInfluencer] = useState(null);
  const [generatingLink, setGeneratingLink] = useState(false);
  const [showInsightsModal, setShowInsightsModal] = useState(false);
  const [insightsInfluencer, setInsightsInfluencer] = useState(null);

  // States para TikTok
  const [showTikTokLinkModal, setShowTikTokLinkModal] = useState(false);
  const [generatedTikTokLink, setGeneratedTikTokLink] = useState('');
  const [tikTokLinkInfluencer, setTikTokLinkInfluencer] = useState(null);
  const [generatingTikTokLink, setGeneratingTikTokLink] = useState(false);

  // States para TikTok Insights Modal
  const [showTikTokInsightsModal, setShowTikTokInsightsModal] = useState(false);
  const [tiktokInsightsInfluencer, setTiktokInsightsInfluencer] = useState(null);

  useEffect(() => {
    loadInfluencers();
  }, []);

  const loadInfluencers = async () => {
    setLoading(true);
    try {
      const response = await contentService.getInfluencers();
      console.log('📋 Respuesta completa:', response);
      console.log('📋 Influencers data:', response.data);

      // Verificar si response.data es un array o está dentro de results
      const influencersList = Array.isArray(response.data)
        ? response.data
        : (response.data?.results || []);

      console.log('📋 Lista final de influencers:', influencersList);
      setInfluencers(influencersList);
    } catch (error) {
      console.error('Error loading influencers:', error);
      alert('Error al cargar influencers');
      setInfluencers([]); // Asegurar que siempre sea array
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = () => {
    setSelectedInfluencer(null);
    setShowModal(true);
  };

  const handleEdit = (influencer) => {
    setSelectedInfluencer(influencer);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Estás seguro de eliminar este influencer?')) return;

    try {
      await contentService.deleteInfluencer(id);
      alert('✅ Influencer eliminado');
      loadInfluencers();
    } catch (error) {
      console.error('Error deleting influencer:', error);
      alert('Error al eliminar influencer');
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedInfluencer(null);
    loadInfluencers();
  };

  const handleGenerateLink = async (influencer) => {
    console.log('🔗 Generando link de Facebook Login para:', influencer.name);
    setGeneratingLink(true);
    try {
      const response = await contentService.generateInstagramLink(influencer.id);
      console.log('📋 Link generado:', response.data);

      if (response.data.success) {
        setGeneratedLink(response.data.link);
        setLinkInfluencer(influencer);
        setShowLinkModal(true);
      } else {
        alert('❌ Error al generar el link');
      }
    } catch (error) {
      console.error('Error generating link:', error);
      alert('❌ Error al generar el link de conexión');
    } finally {
      setGeneratingLink(false);
    }
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(generatedLink);
    alert('✅ Link copiado al portapapeles');
  };

  const handleCloseLinkModal = () => {
    setShowLinkModal(false);
    setGeneratedLink('');
    setLinkInfluencer(null);
  };

  // Funciones para TikTok
  const handleGenerateTikTokLink = async (influencer) => {
    setGeneratingTikTokLink(true);
    try {
      const response = await contentService.generateTikTokLink(influencer.id);
      console.log('📋 Link TikTok generado:', response.data);

      if (response.data.success) {
        setGeneratedTikTokLink(response.data.link);
        setTikTokLinkInfluencer(influencer);
        setShowTikTokLinkModal(true);
      } else {
        alert('❌ Error al generar el link de TikTok');
      }
    } catch (error) {
      console.error('Error generating TikTok link:', error);
      alert('❌ Error al generar el link de conexión TikTok');
    } finally {
      setGeneratingTikTokLink(false);
    }
  };

  const handleCloseTikTokLinkModal = () => {
    setShowTikTokLinkModal(false);
    setGeneratedTikTokLink('');
    setTikTokLinkInfluencer(null);
  };

  // Instagram Direct Login (nueva API)
  const handleGenerateDirectLink = async (influencer) => {
    console.log('📷 Generando link de Instagram Direct para:', influencer.name);
    setGeneratingLink(true);
    try {
      const response = await contentService.generateInstagramDirectLink(influencer.id);
      console.log('📋 Link Instagram Direct generado:', response.data);

      if (response.data.success) {
        setGeneratedLink(response.data.link);
        setLinkInfluencer(influencer);
        setShowLinkModal(true);
      } else {
        alert('❌ Error al generar el link de Instagram Direct');
      }
    } catch (error) {
      console.error('Error generating Instagram Direct link:', error);
      alert('❌ Error al generar el link de Instagram Direct');
    } finally {
      setGeneratingLink(false);
    }
  };

  const handleShowInsights = (influencer) => {
    setInsightsInfluencer(influencer);
    setShowInsightsModal(true);
  };

  const handleCloseInsights = () => {
    setShowInsightsModal(false);
    setInsightsInfluencer(null);
  };

  const handleShowTikTokInsights = (influencer) => {
    setTiktokInsightsInfluencer(influencer);
    setShowTikTokInsightsModal(true);
  };

  const handleCloseTikTokInsights = () => {
    setShowTikTokInsightsModal(false);
    setTiktokInsightsInfluencer(null);
  };

  const filteredInfluencers = influencers.filter(influencer =>
    influencer.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    influencer.username?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    influencer.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Función para obtener el color basado en el número de plataformas
  const getInfluencerColor = (platforms) => {
    if (!platforms || platforms.length === 0) return '#ffffff'; // Blanco (mismo que el fondo de card-contact)
    if (platforms.length === 1) return '#3b82f6';
    if (platforms.length === 2) return '#69B32D';
    if (platforms.length === 3) return '#ec4899';
    return '#10b981'; // 4 o más
  };

  // Función para obtener las iniciales
  const getInitials = (name) => {
    if (!name) return '?';
    const parts = name.split(' ');
    if (parts.length >= 2) {
      return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase();
    }
    return name.charAt(0).toUpperCase();
  };

  return (
    <div className="influencer-list-container">
      {/* Header */}
      <div className="influencer-header">
        <div className="influencer-header-left">
          <h1 className="influencer-title">Cuentas</h1>
          <span className="influencer-count">{filteredInfluencers.length}</span>
        </div>
        <div className="influencer-header-right">
          <input
            type="text"
            placeholder="Buscar..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="il-search-input il-search-header"
          />
          <button onClick={handleCreate} className="il-btn-primary">
            + Cuenta
          </button>
        </div>
      </div>

      {/* Loading */}
      {loading ? (
        <Loading fullScreen={false} />
      ) : (
        <>
          {filteredInfluencers.length === 0 ? (
            <div className="il-empty-state">
              <p>No se encontraron cuentas</p>
              {searchTerm && (
                <button onClick={() => setSearchTerm('')} className="il-btn-secondary">
                  Limpiar búsqueda
                </button>
              )}
            </div>
          ) : (
            <div className="il-table-container">
              <table className="il-table">
                <thead>
                  <tr>
                    <th>Cuenta</th>
                    <th>Estado</th>
                    <th aria-label="Acciones"></th>
                  </tr>
                </thead>
                <tbody>
                  {filteredInfluencers.map((influencer) => (
                    <tr key={influencer.id}>
                      {/* Cuenta */}
                      <td>
                        <div className="il-user-info">
                          <div className="il-avatar" style={{ overflow: 'hidden' }}>
                            {(influencer.profile_image_url_saved || influencer.profile_image_url) ? (
                              <img
                                src={influencer.profile_image_url_saved || influencer.profile_image_url}
                                alt={influencer.name}
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                  e.target.parentElement.textContent = getInitials(influencer.name);
                                }}
                              />
                            ) : (
                              getInitials(influencer.name)
                            )}
                          </div>
                          <div>
                            <div className="il-name">{influencer.name}</div>
                            <div className="il-username">@{influencer.username}</div>
                          </div>
                        </div>
                      </td>

                      {/* Estado */}
                      <td>
                        <span className={`il-status ${influencer.is_active ? 'active' : 'inactive'}`}>
                          {influencer.is_active ? '✓ Activo' : '✗ Inactivo'}
                        </span>
                      </td>

                      {/* Acciones */}
                      <td>
                        <div className="il-actions">
                          <button
                            onClick={() => handleEdit(influencer)}
                            className="il-btn-icon"
                            title="Editar"
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                            </svg>
                          </button>
                          <button
                            onClick={() => handleDelete(influencer.id)}
                            className="il-btn-icon danger"
                            title="Eliminar"
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

      {/* Modal */}
      {showModal && (
        <InfluencerModal
          influencer={selectedInfluencer}
          onClose={handleModalClose}
        />
      )}

      {/* Modal de Link de Instagram */}
      {showLinkModal && linkInfluencer && (
        <div className="modal-overlay" onClick={handleCloseLinkModal}>
          <div className="modal-content link-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-header-content">
                <div className="modal-header-icon">
                  🔗
                </div>
                <div className="modal-header-text">
                  <h2>Link de Conexión Instagram</h2>
                  <p className="header-subtitle">
                    Envía este link a {linkInfluencer.name}
                  </p>
                </div>
              </div>
              <button onClick={handleCloseLinkModal} className="modal-close-btn">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="link-content">
              <p className="link-instructions">
                Copia este link y envíalo al influencer por WhatsApp, Email o el canal que prefieras.
                El link es válido por <strong>7 días</strong>.
              </p>

              <div className="link-box">
                <input
                  type="text"
                  value={generatedLink}
                  readOnly
                  className="link-input"
                  onClick={(e) => e.target.select()}
                />
                <button onClick={handleCopyLink} className="btn-copy">
                  📋 Copiar
                </button>
              </div>

              <div className="link-info">
                <div className="info-item">
                  <span className="info-icon">✓</span>
                  <span className="info-text">El influencer podrá conectar su cuenta profesional de Instagram</span>
                </div>
                <div className="info-item">
                  <span className="info-icon">🔒</span>
                  <span className="info-text">Debe ser administrador de su Página de Facebook</span>
                </div>
                <div className="info-item">
                  <span className="info-icon">⏰</span>
                  <span className="info-text">Link válido por 7 días desde ahora</span>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button onClick={handleCloseLinkModal} className="estado-btn">
                Cerrar
              </button>
              <button onClick={handleCopyLink} className="btn-primary">
                📋 Copiar Link
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Link de TikTok */}
      {showTikTokLinkModal && tikTokLinkInfluencer && (
        <div className="modal-overlay" onClick={handleCloseTikTokLinkModal}>
          <div className="modal-content link-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-header-content">
                <div className="modal-header-icon">
                  🎵
                </div>
                <div className="modal-header-text">
                  <h2>Link de Conexión TikTok</h2>
                  <p className="header-subtitle">
                    Envía este link a {tikTokLinkInfluencer.name}
                  </p>
                </div>
              </div>
              <button onClick={handleCloseTikTokLinkModal} className="modal-close-btn">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="link-content">
              <p className="link-instructions">
                Copia este link y envíalo al influencer por WhatsApp, Email o el canal que prefieras.
                El link es válido por <strong>7 días</strong>.
              </p>

              <div className="link-box">
                <input
                  type="text"
                  value={generatedTikTokLink}
                  readOnly
                  className="link-input"
                  onClick={(e) => e.target.select()}
                />
                <button onClick={() => {
                  navigator.clipboard.writeText(generatedTikTokLink);
                  alert('✅ Link copiado al portapapeles');
                }} className="btn-copy">
                  📋 Copiar
                </button>
              </div>

              <div className="link-info">
                <div className="info-item">
                  <span className="info-icon">✓</span>
                  <span className="info-text">El influencer podrá conectar su cuenta de TikTok</span>
                </div>
                <div className="info-item">
                  <span className="info-icon">🔒</span>
                  <span className="info-text">Debe autorizar el acceso a la aplicación</span>
                </div>
                <div className="info-item">
                  <span className="info-icon">⏰</span>
                  <span className="info-text">Link válido por 7 días desde ahora</span>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button onClick={handleCloseTikTokLinkModal} className="estado-btn">
                Cerrar
              </button>
              <button onClick={() => {
                navigator.clipboard.writeText(generatedTikTokLink);
                alert('✅ Link copiado al portapapeles');
              }} className="btn-primary">
                📋 Copiar Link
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Instagram Insights */}
      {showInsightsModal && insightsInfluencer && (
        <InfluencerModalInstagramDetalle
          influencer={insightsInfluencer}
          onClose={handleCloseInsights}
        />
      )}

      {/* Modal de TikTok Insights */}
      {showTikTokInsightsModal && tiktokInsightsInfluencer && (
        <InfluencerModalTikTokDetalle
          influencer={tiktokInsightsInfluencer}
          onClose={handleCloseTikTokInsights}
        />
      )}
    </div>
  );
};

export default InfluencerList;
